import type { ReactNode } from 'react';

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  fullscreen?: boolean;
}

const Popup = ({ isOpen, onClose, children, fullscreen }: PopupProps) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className={
        fullscreen
          ? 'relative bg-white big-corner shadow-lg p-0 w-[95vw] h-[90vh] max-w-none flex flex-col'
          : 'relative bg-white big-corner shadow-lg p-6 w-[448px] max-w-md'
      }>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl p-2 rounded-full bg-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            className="h-4 w-4"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className={fullscreen ? 'flex-1 overflow-hidden' : ''}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Popup;
